












import Vue from 'vue'
import { mapState } from 'vuex'
import XAppBar from '@/components/atoms/AppBar/XAppBar.vue'
import XDrawer from '@/components/atoms/Drawer/XDrawer.vue'
import XAppFooter from '@/components/atoms/AppFooter/XAppFooter.vue'
import XError from '@/components/atoms/Error/XError.vue'

export default Vue.extend({
  name: 'PrivateLayout',
  components: { XAppBar, XDrawer, XAppFooter, XError },
  computed: {
    ...mapState('auth', ['user']),
  },
  metaInfo() {
    return {
      title: this.$tc(this.$route.meta.title),
      titleTemplate: `%s | ${this.$tc('common.appname')}`,
    }
  },
})
